
import { Options, Vue } from "vue-class-component";
import TurretForm from "@/components/turret/TurretForm.vue";
import Turret from "@/entities/Turret"; // @ is an alias to /src
import Card from "@/components/common/Card.vue";
import AppButton from "@/components/common/AppButton.vue";

@Options({
  components: {
    AppButton,
    TurretForm,
    Card,
  },
})
export default class Home extends Vue {
  private turret: Turret = Turret.createNull();

  setTurret(turret: Turret): void {
    this.$store.commit("setTurret", turret);
    this.turret = turret;
  }
}
